'use strict';

/**
 * VERSION: 版本號
 * VERSION_DATE: 版本發佈日期
 * VERSION_DESC: 版本註記
 * APP_VERSION: APP 最低需求版本，用來判斷 APP 版本是否太舊
 */
module.exports = Object.freeze([
	{
		VERSION: 'Release20211229',
		VERSION_DATE: '2021/12/29',
		VERSION_DESC: '正式版V1.0.0_20211229',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: 'Release20220128',
		VERSION_DATE: '2022/01/28',
		VERSION_DESC: 'V1.0.1.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: 'Release20220301',
		VERSION_DATE: '2022/03/01',
		VERSION_DESC: 'V1.0.2.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: 'Release20220318',
		VERSION_DATE: '2022/03/18',
		VERSION_DESC: '1.0.2.1',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: 'Release20220401',
		VERSION_DATE: '2022/04/01',
		VERSION_DESC: '1.0.3.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: 'Release20220501',
		VERSION_DATE: '2022/05/01',
		VERSION_DESC: '1.0.4.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: 'Release20220517',
		VERSION_DATE: '2022/05/17',
		VERSION_DESC: '2.0.0.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: 'Release20220523',
		VERSION_DATE: '2022/05/23',
		VERSION_DESC: '2.0.0.1',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: 'Release20220601',
		VERSION_DATE: '2022/06/01',
		VERSION_DESC: '2.0.1.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.0.2.0',
		VERSION_DATE: '2022/06/20',
		VERSION_DESC: '2.0.2.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.1.0',
		VERSION_DATE: '2022/07/18',
		VERSION_DESC: '2.1.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.1.1',
		VERSION_DATE: '2022/07/19',
		VERSION_DESC: '2.1.1',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.1.2',
		VERSION_DATE: '2022/08/01',
		VERSION_DESC: '2.1.2',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.1.3',
		VERSION_DATE: '2022/08/09',
		VERSION_DESC: '2.1.3',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.1.4',
		VERSION_DATE: '2022/08/25',
		VERSION_DESC: '2.1.4',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.1.5',
		VERSION_DATE: '2022/08/30',
		VERSION_DESC: '2.1.5',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.2.0',
		VERSION_DATE: '2022/09/01',
		VERSION_DESC: '2.2.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.2.1',
		VERSION_DATE: '2022/09/12',
		VERSION_DESC: '2.2.1',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.3.0',
		VERSION_DATE: '2022/10/07',
		VERSION_DESC: '2.3.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.3.1',
		VERSION_DATE: '2022/10/18',
		VERSION_DESC: '2.3.1',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.3.2',
		VERSION_DATE: '2022/10/31',
		VERSION_DESC: '2.3.2',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.3.3',
		VERSION_DATE: '2022/11/04',
		VERSION_DESC: '2.3.3',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.4.0',
		VERSION_DATE: '2022/11/01',
		VERSION_DESC: '2.4.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.4.1',
		VERSION_DATE: '2022/11/15',
		VERSION_DESC: '2.4.1',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.4.2',
		VERSION_DATE: '2022/11/22',
		VERSION_DESC: '2.4.2',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.4.3',
		VERSION_DATE: '2022/11/30',
		VERSION_DESC: '2.4.3',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.5.0',
		VERSION_DATE: '2022/12/02',
		VERSION_DESC: '2.5.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.5.1',
		VERSION_DATE: '2022/12/13',
		VERSION_DESC: '2.5.1',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.5.2',
		VERSION_DATE: '2022/12/19',
		VERSION_DESC: '2.5.2',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.5.3',
		VERSION_DATE: '2022/12/23',
		VERSION_DESC: '2.5.3',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.5.4',
		VERSION_DATE: '2023/01/06',
		VERSION_DESC: '2.5.4',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.6.0',
		VERSION_DATE: '2023/01/13',
		VERSION_DESC: '2.6.0',
		APP_VERSION: '1.0.1'
	},
	{
		VERSION: '2.6.1',
		VERSION_DATE: '2023/01/18',
		VERSION_DESC: '2.6.1',
		APP_VERSION: '1.0.3'
	},
	{
		VERSION: '2.6.2',
		VERSION_DATE: '2023/01/19',
		VERSION_DESC: '2.6.2',
		APP_VERSION: '1.0.3'
	},
	{
		VERSION: '2.6.3',
		VERSION_DATE: '2023/02/07',
		VERSION_DESC: '2.6.3',
		APP_VERSION: '1.0.5'
	},
	{
		VERSION: '2.6.4',
		VERSION_DATE: '2023/02/08',
		VERSION_DESC: '2.6.4',
		APP_VERSION: '1.0.5'
	},
	{
		VERSION: '2.6.5',
		VERSION_DATE: '2023/02/15',
		VERSION_DESC: '2.6.5',
		APP_VERSION: '1.0.6'
	},
	{
		VERSION: '2.6.10',
		VERSION_DATE: '2023/02/27',
		VERSION_DESC: '2.6.10',
		APP_VERSION: '1.0.7'
	},
	{
		VERSION: '2.6.11',
		VERSION_DATE: '2023/03/03',
		VERSION_DESC: '2.6.11',
		APP_VERSION: '1.0.7'
	},
	{
		VERSION: '2.6.12',
		VERSION_DATE: '2023/03/17',
		VERSION_DESC: '2.6.12',
		APP_VERSION: '1.0.7'
	},
	{
		VERSION: '2.7.0',
		VERSION_DATE: '2023/03/27',
		VERSION_DESC: '2.7.0',
		APP_VERSION: '1.0.7'
	},
	{
		VERSION: '2.7.1',
		VERSION_DATE: '2023/04/10',
		VERSION_DESC: '2.7.1',
		APP_VERSION: '1.0.7'
	},
	{
		VERSION: '2.7.10',
		VERSION_DATE: '2023/04/28',
		VERSION_DESC: '2.7.10',
		APP_VERSION: '1.0.8'
	},
	{
		VERSION: '2.8.0',
		VERSION_DATE: '2023/06/26',
		VERSION_DESC: '2.8.0',
		APP_VERSION: '1.0.8'
	},
	{
		VERSION: '2.8.1',
		VERSION_DATE: '2023/07/12',
		VERSION_DESC: '2.8.1',
		APP_VERSION: '1.0.8'
	},
	{
		VERSION: '2.9.0',
		VERSION_DATE: '2023/09/22',
		VERSION_DESC: '2.9.0',
		APP_VERSION: '1.1.1'
	},
	{
		VERSION: '2.9.1',
		VERSION_DATE: '2023/10/12',
		VERSION_DESC: '2.9.1',
		APP_VERSION: '1.1.1'
	},
	{
		VERSION: '2.10.0',
		VERSION_DATE: '2023/12/18',
		VERSION_DESC: '2.10.0',
		APP_VERSION: '1.1.3'
	},
	{
		VERSION: '2.10.1',
		VERSION_DATE: '2023/12/20',
		VERSION_DESC: '2.10.1',
		APP_VERSION: '1.1.3'
	},
	{
		VERSION: '2.10.2',
		VERSION_DATE: '2023/12/25',
		VERSION_DESC: '2.10.2',
		APP_VERSION: '1.1.3'
	},
	{
		VERSION: '2.10.3',
		VERSION_DATE: '2024/01/04',
		VERSION_DESC: '2.10.3',
		APP_VERSION: '1.1.3'
	},
	{
		VERSION: '2.10.4',
		VERSION_DATE: '2024/01/19',
		VERSION_DESC: '2.10.4',
		APP_VERSION: '1.1.3'
	},
	{
		VERSION: '2.10.5',
		VERSION_DATE: '2024/03/22',
		VERSION_DESC: '2.10.5',
		APP_VERSION: '1.1.6'
	},
	{
		VERSION: '2.11.0',
		VERSION_DATE: '2024/04/10',
		VERSION_DESC: '2.11.0',
		APP_VERSION: '1.1.7'
	},
	{
		VERSION: '2.11.2',
		VERSION_DATE: '2024/04/26',
		VERSION_DESC: '2.11.2',
		APP_VERSION: '1.1.7'
	},
	{
		VERSION: '2.12.0',
		VERSION_DATE: '2024/07/03',
		VERSION_DESC: '2.12.0',
		APP_VERSION: '1.1.9'
	},
	{
		VERSION: '2.12.1',
		VERSION_DATE: '2024/07/15',
		VERSION_DESC: '2.12.1',
		APP_VERSION: '1.1.9'
	},
	{
		VERSION: '2.12.2',
		VERSION_DATE: '2024/07/19',
		VERSION_DESC: '2.12.2',
		APP_VERSION: '1.1.9'
	},
	{
		VERSION: '2.12.3',
		VERSION_DATE: '2024/07/29',
		VERSION_DESC: '2.12.3',
		APP_VERSION: '1.1.9'
	},
	{
		VERSION: '2.13.0',
		VERSION_DATE: '2024/08/27',
		VERSION_DESC: '2.13.0',
		APP_VERSION: '1.1.11'
	},
	{
		VERSION: '2.14.0',
		VERSION_DATE: '2024/11/04',
		VERSION_DESC: '2.14.0',
		APP_VERSION: '1.1.12'
	},
	{
		VERSION: '2.14.1',
		VERSION_DATE: '2024/12/24',
		VERSION_DESC: '2.14.1',
		APP_VERSION: '1.1.12'
	},
	{
		VERSION: '2.14.2',
		VERSION_DATE: '2024/12/27',
		VERSION_DESC: '2.14.2',
		APP_VERSION: '1.1.12'
	},
	{
		VERSION: '2.14.3',
		VERSION_DATE: '2024/01/15',
		VERSION_DESC: '2.14.3',
		APP_VERSION: '1.1.12'
	},
	{
		VERSION: '2.15.0',
		VERSION_DATE: '2025/02/20',
		VERSION_DESC: '2.15.0',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.1',
		VERSION_DATE: '2025/04/21',
		VERSION_DESC: '2.15.1',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.2',
		VERSION_DATE: '2025/04/30',
		VERSION_DESC: '2.15.2',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.3',
		VERSION_DATE: '2025/05/05',
		VERSION_DESC: '2.15.3',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.4',
		VERSION_DATE: '2025/05/15',
		VERSION_DESC: '2.15.4',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.5',
		VERSION_DATE: '2025/06/16',
		VERSION_DESC: '2.15.5',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.6',
		VERSION_DATE: '2025/07/01',
		VERSION_DESC: '2.15.6',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.7',
		VERSION_DATE: '2025/07/07',
		VERSION_DESC: '2.15.7',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.8',
		VERSION_DATE: '2025/07/11',
		VERSION_DESC: '2.15.8',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.9',
		VERSION_DATE: '2025/07/17',
		VERSION_DESC: '2.15.9',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.10',
		VERSION_DATE: '2025/07/31',
		VERSION_DESC: '2.15.10',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.11',
		VERSION_DATE: '2025/08/08',
		VERSION_DESC: '2.15.11',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.12',
		VERSION_DATE: '2025/08/26',
		VERSION_DESC: '2.15.12',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.15.13',
		VERSION_DATE: '2025/09/04',
		VERSION_DESC: '2.15.13',
		APP_VERSION: '1.1.13'
	},
	{
		VERSION: '2.16.0',
		VERSION_DATE: '2025/07/09',
		VERSION_DESC: '2.16.0',
		APP_VERSION: '1.1.21'
	},
	{
		VERSION: '2.16.1',
		VERSION_DATE: '2025/09/09',
		VERSION_DESC: '2.16.1',
		APP_VERSION: '1.1.21'
	},
	{
		VERSION: '2.16.2',
		VERSION_DATE: '2025/10/22',
		VERSION_DESC: '2.16.2',
		APP_VERSION: '1.1.21'
	},
	{
		VERSION: '2.16.3',
		VERSION_DATE: '2025/11/05',
		VERSION_DESC: '2.16.3',
		APP_VERSION: '1.1.21'
	},
	{
		VERSION: '2.16.4',
		VERSION_DATE: '2025/11/20',
		VERSION_DESC: '2.16.4',
		APP_VERSION: '1.1.21'
	},
	{
		VERSION: '2.17.0',
		VERSION_DATE: '2025/10/14',
		VERSION_DESC: '2.17.0',
		APP_VERSION: '1.1.25'
	},
	{
		VERSION: '2.17.1',
		VERSION_DATE: '2025/12/24',
		VERSION_DESC: '2.17.1',
		APP_VERSION: '1.1.25'
	},
	{
		VERSION: '2.17.2',
		VERSION_DATE: '2026/01/05',
		VERSION_DESC: '2.17.2',
		APP_VERSION: '1.1.25'
	},
	{
		VERSION: '2.17.3',
		VERSION_DATE: '2026/01/14',
		VERSION_DESC: '2.17.3',
		APP_VERSION: '1.1.25'
	},
	{
		VERSION: '2.17.4',
		VERSION_DATE: '2026/01/21',
		VERSION_DESC: '2.17.4',
		APP_VERSION: '1.1.25'
	},
	{
		VERSION: '2.17.5',
		VERSION_DATE: '2026/02/25',
		VERSION_DESC: '2.17.5',
		APP_VERSION: '1.1.25'
	},
	{
		VERSION: '2.17.6',
		VERSION_DATE: '2026/03/25',
		VERSION_DESC: '2.17.6',
		APP_VERSION: '1.1.25'
	},
	{
		VERSION: '2.18.0',
		VERSION_DATE: '2026/04/21',
		VERSION_DESC: '2.18.0',
		APP_VERSION: '1.2.1'
	},
	{
		VERSION: '2.18.1',
		VERSION_DATE: '2026/05/05',
		VERSION_DESC: '2.18.1',
		APP_VERSION: '1.2.1'
	},
	{
		VERSION: '2.18.2',
		VERSION_DATE: '2026/06/16',
		VERSION_DESC: '2.18.2',
		APP_VERSION: '1.2.1'
	},
	{
		VERSION: '2.18.3',
		VERSION_DATE: '2026/06/22',
		VERSION_DESC: '2.18.3',
		APP_VERSION: '1.2.1'
	},
	{
		VERSION: '2.18.4',
		VERSION_DATE: '2026/07/15',
		VERSION_DESC: '2.18.4',
		APP_VERSION: '1.2.1'
	},
	{
		VERSION: '2.18.5',
		VERSION_DATE: '2026/07/20',
		VERSION_DESC: '2.18.5',
		APP_VERSION: '1.2.1'
	},
	{
		VERSION: '2.19.0',
		VERSION_DATE: '2026/09/22',
		VERSION_DESC: '2.19.0',
		APP_VERSION: '1.2.4'
	},
	{
		VERSION: '2.19.1',
		VERSION_DATE: '2026/09/29',
		VERSION_DESC: '2.19.1',
		APP_VERSION: '1.2.4'
	},
	{
		VERSION: '2.19.2',
		VERSION_DATE: '2026/10/13',
		VERSION_DESC: '2.19.2',
		APP_VERSION: '1.2.4'
	},
]);
